<template>
  <div class="lang-switcher">
    <button v-if="countryId !== '2'" :class="{ active: locale === 'bs' || locale === 'lat-ekavica' }"
      @click="switchTo('bs')" aria-label="Latinica">
      LAT
    </button>
    <button v-if="countryId !== '2'" :class="{ active: locale === 'sr' || locale === 'cir-ekavica' }"
      @click="switchTo('sr')" aria-label="Cirilica">
      ЋИР
    </button>

    <button v-if="countryId === '2'" :class="{ active: locale === 'en' }" @click="switchTo('en')" aria-label="English">
      ENG
    </button>

    <!-- Loader overlay -->
    <div v-if="loading" class="lang-loader-overlay">
      <div class="lang-loader-spinner" />
    </div>

  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLocale } from 'vuetify'
import axios from 'axios'

const { locale, t } = useI18n({ useScope: 'global' })
const { current: vuetifyLocale } = useLocale()
const loading = ref(false)
const countryId = ref(localStorage.getItem('CountryId'))

async function switchTo(lang) {
  // Mapiranje za Srbiju
  let resolvedLang = lang
  if (countryId.value === '3') {
    resolvedLang = lang === 'sr' ? 'cir-ekavica' : 'lat-ekavica'
  }

  if (locale.value === resolvedLang) return
  loading.value = true

  locale.value = resolvedLang
  vuetifyLocale.value = resolvedLang
  localStorage.setItem('lang', resolvedLang)

  const languageId = resolvedLang === 'sr' ? 1
    : resolvedLang === 'bs' ? 2
      : resolvedLang === 'cir-ekavica' ? 4
        : resolvedLang === 'lat-ekavica' ? 3
          : 2
  localStorage.setItem('LanguageId', languageId)

  const userId = localStorage.getItem('UserId')
  if (userId) {
    try {
      await axios.put('User/Language', {
        Id: Number(localStorage.getItem('UserId')),
        LanguageId: languageId
      })
    } catch (err) {
      console.error(t('general.langErr'), err)
    }
  }

  window.location.reload()
}
</script>

<style scoped>
.lang-switcher {
  position: relative;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  margin-right: 30px;
}

button {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.6px;
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.35);
  padding: 4px 6px;
  transition: color 0.2s;
}

button:hover {
  color: #ffffff;
}

button.active {
  color: #FFFFFF;
  outline: none;
  border: none;
}

button:focus {
  outline: none;
}

.nav-item-logout {
  font-size: 14px;
  margin-left: 10px;
  background: none;
  color: #fff;
  cursor: pointer;
  border: 1px solid #ccc;
  padding: 6px 10px;
  border-radius: 6px;
  transition: background-color 0.2s ease-in-out;
  text-transform: uppercase;
}

.nav-item-logout:hover {
  background-color: #FFFFFF;
}

.lang-loader-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.lang-loader-spinner {
  width: 48px;
  height: 48px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
